<script lang="ts">
    import {_} from 'svelte-i18n'
    import type {Conversation, Session} from './types';
    import {Role} from './types';
    import OperatorWaitingRoom from './OperatorWaitingRoom.svelte';
    import {myNotFinishedConversation, mySession, paths, walker} from './services';
    import Layout from './Layout.svelte';
    import {onDestroy} from 'svelte';
    import {derived, get} from 'svelte/store';

    const redirectConversation = derived([mySession, myNotFinishedConversation], ([_mySession, _myNotFinishedConversation]: [Session, Conversation]) => {
        if (_mySession.roles.includes(Role.CLIENT) && _myNotFinishedConversation) {
            return _myNotFinishedConversation;
        }
        return null;
    });
    const unsubscribe = redirectConversation.subscribe((_redirectConversation: Conversation | null) => {
        if (_redirectConversation) {
            walker.goTo(get(paths).conversation(_redirectConversation));
        }
    });
    onDestroy(unsubscribe);

</script>

<Layout>
    {#if $mySession.roles.includes(Role.OPERATOR) || $mySession.roles.includes(Role.INTERVISOR)}
        <OperatorWaitingRoom />
    {/if}
    {#if $mySession.roles.includes(Role.CLIENT)}
        <div style="height: 100%; display: flex; flex-direction: column; align-items: center; text-align: center; justify-content: center;">
            <div class="mdc-typography--headline4" style="margin: 5px 0; padding: 5px 0">{$_('chat.ByeMessage')}</div>
        </div>
    {/if}
</Layout>